import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import IsLoading from "../components/loading/Loading";

const Home = lazy(() => import("../pages/Home"));

export default function AppRouter() {
  return (
    <Suspense fallback={<IsLoading />}>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Suspense>
  );
}